import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'; 
import { Typography, Tabs, Form, Upload, Input, Button, message, DatePicker } from 'antd';
import UploadOutlined from '@ant-design/icons/UploadOutlined'
import LoadingOutlined from '@ant-design/icons/LoadingOutlined'
import PlusOutlined from '@ant-design/icons/PlusOutlined'
import swal from "sweetalert";
import moment from 'moment'

import { storage, db, timestamp, auth } from '../../firebase'
import { mailer } from '../ApprovalPage/sendMail';

const { Title, Text, Link } = Typography;
const { TabPane } = Tabs;

const START_OF_PREREGISTRATION = moment(new Date(2021, 3, 19, 0, 0, 0))
const END_OF_PREREGISTRATION = moment(new Date(2021, 4, 13))
const dateFormat = 'YYYY/MM/DD';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 8 },
};

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    message.error('Image must smaller than 5MB.');
  }
  return isJpgOrPng && isLt5M ? true : Upload.LIST_IGNORE;
}

function beforeUploadPdf(file) {
  const isJpgOrPng = file.type === 'application/pdf';
  if (!isJpgOrPng) {
    message.error('You can only upload PDF file.');
  }
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    message.error('Image must smaller than 5MB.');
  }
  return isJpgOrPng && isLt5M ? true : Upload.LIST_IGNORE;
}

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function PreRegister() {
    const [form] = Form.useForm()
    const [form2] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [imageUrl, setImageUrl] = useState(null)
    const [img1, setImg1] = useState(null)
    const [img2, setImg2] = useState(null)
    const [img3, setImg3] = useState(null)
    
    const handleChange = info => {
      if (info.file.status === 'uploading') {
        setLoading(true)
        return;
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          setImageUrl(imageUrl);
          setLoading(false)
        }
        );
      }
    };
  
    const onFinish = (values) => {
      const currentDate = moment(new Date())
      if(currentDate.isBefore(START_OF_PREREGISTRATION)) return swal("Oops!", "Pre-registration period starts on 19 April 2021.", "warning")
      if(currentDate.isAfter(END_OF_PREREGISTRATION)) return swal('Oops!', "Pre-registration period has ended.", "warning")

      const data = { ...values }
      data.authorizationLetter = img3
      data.birthdate = values.birthdate ? timestamp.fromDate(values.birthdate?.toDate()) : null
      data.govtId = img2
      data.photo = img1
      data.isApproved = false
      data.hasVoted = false
      data.type = "Stockholder"
      data.noOfShares = null
      data.remarks = null
      data.dateRegistered = timestamp.fromDate(new Date())
  


      db.collection('users').doc(data.email).get().then(doc => {
        if(!doc.exists || doc.data().remarks !== null) {
          db.collection('users').doc(data.email)
            .set(data)
            .then(res => {
                mailer("mpbiag@stocktransfer.com.ph", "New Registration for Megawide Construction Corporation's 2021 Special Stockholders' Meeting", "register")
                swal('Thank you for your registration', 'Upon validation, a username and password shall be sent to your email.', 'success')
                    .then(() => {
                        form.resetFields()
                        form2.resetFields()
                    })
            })
        } else {
            swal('Oops!', 'The email is already registered and is waiting approval.', 'warning')
                .then(() => {
                    form.resetFields()
                    form2.resetFields()
                })
        }
      })
      .catch(err => swal('Something went wrong', err, 'error'))
    };
  
    // const signup = () => {
    //   auth.createUserWithEmailAndPassword('jjulaton@megawide.com.ph', '#Megawide!#').then(res => console.log(res))
    // }
  
    const onFinishFailed = (errorInfo) => {
      console.log('Failed:', errorInfo);
    };
  
    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
  
    const customUpload1 = ({ onError, onSuccess, file }) => {
      const ext = file.name.split(".").pop()
      const storageRef = storage.ref();
      const imageName = uuidv4(); //a unique name for the image
      const imgFile = storageRef.child(`${imageName}.${ext}`);
      try {
        const image = imgFile.put(file);
        image.on(
          "state_changed",
          snapshot => {},
          error => {
            console.log(error)
          },
          () => {
            imgFile.getDownloadURL().then(url => {
              setImg1(url)
            })
          }
        )
        onSuccess(null, image);
      } catch(e) {
        onError(e);
      }
    };
  
    const customUpload2 = ({ onError, onSuccess, file }) => {
      const ext = file.name.split(".").pop()
      const storageRef = storage.ref();
      const imageName = uuidv4(); //a unique name for the image
      const imgFile = storageRef.child(`${imageName}.${ext}`);
      try {
        const image = imgFile.put(file);
        image.on(
          "state_changed",
          snapshot => {},
          error => {
            console.log(error)
          },
          () => {
            imgFile.getDownloadURL().then(url => {
              setImg2(url)
            })
          }
        )
        onSuccess(null, image);
      } catch(e) {
        onError(e);
      }
    };
  
    const customUpload3 = ({ onError, onSuccess, file }) => {
      const ext = file.name.split(".").pop()
      const storageRef = storage.ref();
      const imageName = uuidv4(); //a unique name for the image
      const imgFile = storageRef.child(`${imageName}.${ext}`);
      try {
        const image = imgFile.put(file);
        image.on(
          "state_changed",
          snapshot => {},
          error => {
            console.log(error)
          },
          () => {
            imgFile.getDownloadURL().then(url => {
              setImg3(url)
            })
          }
        )
        onSuccess(null, image);
      } catch(e) {
        onError(e);
      }
    };

    return (
        <Tabs defaultActiveKey="1" >
              <TabPane tab="Individual Stockholders" key="1" style={{ fontSize: '2rem'}}>
                <Form { ...layout } form={form} name="basic" onFinish={onFinish} onFinishFailed={onFinishFailed}>
                  <Form.Item
                    label="Fullname"
                    name="fullname"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your full name.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Address"
                    name="address"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your address.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Birthdate"
                    name="birthdate"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your birthdate.',
                      },
                    ]}
                  >
                    <DatePicker format={dateFormat} style={{width: '100%'}} />
                  </Form.Item>
                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your email.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Phone Number"
                    name="phoneNumber"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Mobile Number"
                    name="mobileNumber"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your mobile number.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Current photograph, with face fully visible"
                    name="photo"
                    rules={[
                      {
                        required: true,
                        message: 'Please upload your recent photo.',
                      },
                    ]}
                  >
                    <Upload 
                      customRequest={customUpload1}
                      listType="picture-card"
                      showUploadList={false} 
                      beforeUpload={beforeUpload}
                      onChange={handleChange}>
                      {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                  </Form.Item>
                  <Form.Item
                    label="Scanned copy of valid government-issued ID"
                    name="govtId"
                    rules={[
                      {
                        required: true,
                        message: 'Please upload a valid government ID.',
                      },
                    ]}
                  >
                    <Upload 
                      maxCount={1}
                      beforeUpload={beforeUpload}
                      customRequest={customUpload2}>
                        <Button icon={<UploadOutlined />}>Upload PNG/JPG only</Button>
                    </Upload>
                  </Form.Item>
                  <Form.Item
                    label="Authorization Letter (For Stockholders with Joint Account)"
                    name="authorizationLetter"
                    rules={[
                      {
                        required: true,
                        message: 'Please upload a valid authorization letter.',
                      },
                    ]}
                  >
                    <Upload
                      maxCount={1}
                      beforeUpload={beforeUploadPdf}
                      customRequest={customUpload3}>
                        <Button icon={<UploadOutlined />}>Upload PDF file only</Button>
                    </Upload>
                  </Form.Item>
                  <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </Form.Item>
                </Form>

                {/* <Button onClick={() => signup()}>Temp Signup</Button> */}
              </TabPane>
              <TabPane tab="Corporate Stockholders" key="2">
              <Form { ...layout } form={form2} name="basic" onFinish={onFinish} onFinishFailed={onFinishFailed}>
                  <Form.Item
                    label="Corporate Name"
                    name="fullname"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your corporate name.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Address"
                    name="address"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your address.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your email.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Phone Number"
                    name="phoneNumber"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Mobile Number"
                    name="mobileNumber"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your mobile number.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Scanned copy of the Secretary’s Certificate or Board Resolution"
                    name="authorizationLetter"
                    rules={[
                      {
                        required: true,
                        message: 'Please upload a authorization letter.',
                      },
                    ]}
                  >
                    <Upload
                      maxCount={1}
                      beforeUpload={beforeUploadPdf}
                      customRequest={customUpload3}>
                        <Button icon={<UploadOutlined />}>Upload PDF file only</Button>
                    </Upload>
                  </Form.Item>
                  <Form.Item
                    label="Current photograph of Authorized Representative"
                    name="photo"
                    rules={[
                      {
                        required: true,
                        message: 'Please upload your recent photo.',
                      },
                    ]}
                  >
                    <Upload 
                      customRequest={customUpload1}
                      listType="picture-card"
                      showUploadList={false} 
                      beforeUpload={beforeUpload}
                      onChange={handleChange}>
                      {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                  </Form.Item>
                  <Form.Item
                    label="Scanned copy of valid government-issued ID of the Authorized Representative"
                    name="govtId"
                    rules={[
                      {
                        required: true,
                        message: 'Please upload a valid government ID.',
                      },
                    ]}
                  >
                    <Upload 
                      maxCount={1}
                      beforeUpload={beforeUpload}
                      customRequest={customUpload2}>
                        <Button icon={<UploadOutlined />}>Upload png only</Button>
                    </Upload>
                  </Form.Item>
                  <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </TabPane>
            </Tabs>
    )
}

export default PreRegister
